import { Lightning } from "@lightningjs/sdk";
import configs from "../../../../lib/configs";
import { PlayerBottomColumn } from "./PlayerBottomColumn";
import { PlayerBottomRow } from "./PlayerBottomRow";

interface PlayerBottomTemplateSpec extends Lightning.Component.TemplateSpec {
    Controls: typeof PlayerBottomColumn | typeof PlayerBottomRow;
    duration: number;
    currentTime: number;
}

export class PlayerBottom
    extends Lightning.Component<PlayerBottomTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<PlayerBottomTemplateSpec>
{
    readonly Controls = this.getByRef("Controls")!;

    static override _template(): Lightning.Component.Template<PlayerBottomTemplateSpec> {
        const controlsLayout = (configs.layout?.playback?.controls as "column" | "row") || "column";
        const isRowLayout = controlsLayout === "row";
        return {
            collision: true,
            zIndex: 10,
            Controls: {
                type: isRowLayout ? PlayerBottomRow : PlayerBottomColumn
            }
        };
    }

    override _getFocused() {
        return this.Controls;
    }

    setHasSettings(hasSettings: boolean) {
        if (this.Controls.setHasSettings) {
            this.Controls.setHasSettings(hasSettings);
        }
    }

    $setFocusToSettingIcon() {
        if (this.Controls.$setFocusToSettingIcon) {
            this.Controls.$setFocusToSettingIcon();
        }
    }

    getSettingIcon() {
        if (this.Controls.getSettingIcon) {
            return this.Controls.getSettingIcon();
        }
        return null;
    }

    hideSettingIcon() {
        if (this.Controls.hideSettingIcon) {
            this.Controls.hideSettingIcon();
        }
    }

    showSettingIcon() {
        if (this.Controls.showSettingIcon) {
            this.Controls.showSettingIcon();
        }
    }

    get PlayPause() {
        return (this.Controls as any).PlayPause;
    }

    triggeredPlayPause() {
        if (this.Controls.triggeredPlayPause) {
            this.Controls.triggeredPlayPause();
        }
    }

    triggeredPause() {
        if (this.Controls.triggeredPause) {
            this.Controls.triggeredPause();
        }
    }

    triggeredPlay() {
        this.Controls.triggeredPlay();
    }

    setPlayState(value: boolean) {
        this.Controls.setPlayState(value);
    }

    setRewindState() {
        this.Controls.setRewindState();
    }

    setPlayPauseState() {
        this.Controls.setPlayPauseState();
    }

    setForwardState() {
        this.Controls.setForwardState();
    }

    set duration(value: number) {
        this.Controls.patch({
            duration: value
        });
    }

    set currentTime(value: number) {
        this.Controls.patch({
            currentTime: value
        });
    }
}
